import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { OffersPage } from '@/areas/market-insights/MarketInsights/pages/OffersPage/OffersPage';
import type { PageStaticData } from '@/shared/routing';

// The monitoring layout (`monitoring/route.tsx`) checks who may open this page.
export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/offers')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: z.object({
        partIds: z.string().optional(),
        componentIds: z.string().optional(),
        partId: z.string().optional(),
        supplierId: z.string().optional(),
        stockLocation: z.string().optional(),
        startDate: z.string().optional(),
        endDate: z.string().optional(),
        asOf: z.string().optional(),
        summaryState: z.string().optional(),
        // Do not coerce an invalid grouping to undefined: that would broaden the search.
        groupBy: z.enum(['supplier', 'stockLocation']).optional(),
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <OffersPage />;
}
